import { create } from 'zustand'
import { persist } from 'zustand/middleware'

// Light / dark only. "System" was dropped — it resolved to dark on every machine
// here, so the three-way cycle just made the button feel broken.

export function applyTheme(mode) {
  if (typeof document === 'undefined') return
  document.documentElement.classList.toggle('dark', mode !== 'light')
}

const useUIStore = create(
  persist(
    (set, get) => ({
      theme: 'dark',
      sidebarCollapsed: false,

      setTheme: (theme) => {
        const t = theme === 'light' ? 'light' : 'dark'
        applyTheme(t)
        set({ theme: t })
      },

      toggleTheme: () => {
        const next = get().theme === 'dark' ? 'light' : 'dark'
        get().setTheme(next)
        return next
      },

      toggleSidebar: () => set({ sidebarCollapsed: !get().sidebarCollapsed }),
      setSidebarCollapsed: (v) => set({ sidebarCollapsed: !!v }),
    }),
    {
      name: 'cooppress_ui',
      onRehydrateStorage: () => (state) => {
        if (!state) return
        // migrate anyone stuck on the old 'system' value
        if (state.theme !== 'light' && state.theme !== 'dark') state.theme = 'dark'
        applyTheme(state.theme)
      },
    },
  ),
)

export default useUIStore
